<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content-noneheader">
        <!-- Multiple select-->
        <div class="box">
          <div class="box-header with-border">
            <el-breadcrumb separator="/" v-if>
              <el-breadcrumb-item>意见反馈</el-breadcrumb-item>
              <el-breadcrumb-item>反馈列表</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="box-body" style="min-height:80%;">
            <div class="search-div">
              <el-select v-model="selectValue" clearable placeholder="是否处理">
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>

              <el-select v-model="typeValue" clearable placeholder="请选择类型">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button type="primary" icon="el-icon-search" class="button-pull-right" @click="search()">搜索</el-button>
              <br/>
            </div>
            <el-table
              ref="multipleTable"
              :data="dt.data"
              :stripe="true"
              border
              highlight-current-row
              style="width: 100%"
              :size="dt.size"
              @sort-change="dt.handleSortChange"
              @selection-change="dt.handleSelectionChange">
              <el-table-column
                type="selection"
                min-width=5%>
              </el-table-column>
              <el-table-column
                property="id"
                label="ID"
                min-width=5%>
              </el-table-column>
              <el-table-column
                property="user.name"
                label="用户"
                min-width=10%
                :show-overflow-tooltip="true"
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="food.name"
                label="食物"
                min-width=10%
                :show-overflow-tooltip="true"
                sortable="custom">
              </el-table-column>
              <el-table-column
                property="content"
                label="内容"
                min-width=30%
                :show-overflow-tooltip="true"
                sortable="custom">
              </el-table-column>
              <el-table-column
                prop="type"
                label="类型"
                min-width=10%
                sortable="custom">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.type === 1 ? 'primary' : scope.row.type === 2?'info':'success'"
                    close-transition>{{scope.row.type==1?'功能建议': scope.row.type === 2?'产品bug': scope.row.type === 4?'食物报错':'其他问题'}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                label="状态"
                min-width=10%
                sortable="custom">
                <template slot-scope="scope">
                  <el-tag
                    :type="scope.row.status=='UNDISPOSED' ? 'primary':'success'"
                    close-transition>{{scope.row.status=='UNDISPOSED'?'未处理': '已处理'}}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width=20%>
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    :plain="true"
                    @click="handleEdit(scope.$index, scope.row)">查看
                  </el-button>
                  <template v-if="scope.row.status=='UNDISPOSED'">
                    <el-button
                      size="mini"
                      type="warning"
                      :plain="true"
                      @click="handleStatus(scope.$index, scope.row)">处理
                    </el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="dt.handleSizeChange"
              @current-change="dt.handleCurrentChange"
              :current-page="dt.currentPage"
              :page-sizes="dt.pageSizes"
              :page-size="dt.pageSize"
              :layout="dt.layout"
              :total="dt.totalElements">
            </el-pagination>
          </div>
        </div>
        <!-- End of Multiple select-->
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
  import {DataTable} from "../../../data-table";

  export default {
    name: 'FeedbackList',
    data: function () {
      let that = this;
      return {
        //  表格设置
        filter: [],
        dt: DataTable.getInstance(that, '/admin/feedback/findPage'),

        selectOptions: [
          {
            value: 'PROCESSED',
            label: '已处理'
          }, {
            value: 'UNDISPOSED',
            label: '未处理'
          }],
        selectValue: '',

        typeOptions: [
          {
            value: '3',
            label: '其他问题'
          }, {
            value: '4',
            label: '食物报错'
          }],
        typeValue: null
      }
    },

    mounted: function () {
      let filters = this.dt.filters;
      if (filters != null && filters instanceof Array) {
        for (let i = 0; i < filters.length; i++) {
          let f = filters[i];
          switch (f.name) {
            case "status":
              this.selectValue = f.value;
              break;
            case "type":
              this.typeValue = f.value;
              break;
          }
        }
      }
      //  向后台查询数据
      this.dt.queryPageData()
    },

    methods: {
      search: function () {
        if (this.filter) {
          this.filter.length = 0;
        }
        var key = {};
        if (this.selectValue !== '') {
          key.name = 'status'
          key.value = this.selectValue
          key.type = 'enum'
          key.enumName = 'com.beiyingqian.app.jpa.feedback.FeedbackStatus'
          this.filter.push(key)
        }
        if (this.typeValue && this.typeValue !== '') {
          key.name = 'type';
          key.type = 'number';
          key.value = this.typeValue;
          this.filter.push(key)
        }
        this.dt.filters = this.filter;
        this.dt.queryPageData()
      },
      // 编辑记录
      handleEdit: function (index, row) {
        this.$router.push({path: '/feedback/feedbackModify', query: {id: row.id}})
      },
      handleDelete: function (index, row) {
      },
      handleStatus: function (index, row) {
        this.axios.post('/admin/feedback/updateStatus', [], {params: {id: row.id}})
          .then(resp => {
            if (resp.data.code === 200) {
              this.dt.queryPageData()
              this.$message({
                type: 'success',
                message: '处理成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: '处理失敗'
              })
            }
          }).catch(resp => {
          this.$message({
            type: 'error',
            message: '处理失敗'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FeedbackList.vue?0b3c1cc5